import React, { Component, createRef, useEffect, useState } from "react";
import Button from "../components/Button";
import NumberInput from "../components/NumberInput";
import { randomDigit } from "../utils/random";
import { BACKWARD } from "./../config/gameDigitalSpan";
import Howtoplay from "../components/Howtoplay";
import Waiting from "../components/Waiting";
import Game from "../containers/Game";
import Passpracetice from "../components/Passpracetice";
import StatusGame from "../components/StatusGame";
import styles from "./gamedigitalspan.module.css";
import IntroGame from "../components/IntroGame";
import { GameData } from "../containers/GameContainer";
import ButtonNextLevel from "../components/ButtonNextLevel";
import ButtonNextGame from "../components/ButtonNextGame";
import { useData } from "../contexts/DataContext";
import CountdownTimer from "../components/CountdownTimer";
import LevelResult from "../components/LevelResult";
import Numpad from "../components/Numpad";
import ButtonEndGame from "../components/ButtonEndGame";
import ModalEndGame from "../components/ModalEndGame";

class GameDigitalSpan extends Component {
  constructor(gameType) {
    super();
    this.type = gameType;

    // game loop
    this.animationID = null;
    this.lastUpdate = null;
    this.questionShowAt = null;

    this.gameSetting = BACKWARD;

    // game state
    this.state = {
      id: "3",
      showIntro: true,
      showHowtoplay: false,
      showLevel: false,
      passLevel: false,
      action: "cooldown",
      level: 0,
      result: Array(this.gameSetting.level.length).fill(""),
      currentDigit: 0,
      inputValue: 0,
      question: null,
      isModalEndGame: false,
      values: new Array(this.gameSetting.level[0].digit).fill(""),
      thisMobile: !window.matchMedia("(min-width: 768px)").matches,
    };
    this.inputRefs = [];

    this.answerBtnRef = createRef();
    [...Array(10).keys()].forEach((i) => (this["inputRefs" + i] = createRef()));
  }

  componentDidUpdate(_, prevState) {
    if (
      this.state.action !== prevState.action &&
      this.state.action === "answer"
    ) {
      if (this.inputRefs.length !== 0) {
        if (this.state.values.every((x) => x === "")) {
          if (this.inputRefs[0] !== null) this.inputRefs[0].focus();
        }
      }

      this.questionShowAt = new Date();
    }
  }

  restartGame() {
    this.setState({
      showIntro: false,
      showHowtoplay: true,
      level: 0,
      result: Array(this.gameSetting.level.length).fill(""),
      values: new Array(this.gameSetting.level[0].digit).fill(""),
    });
  }

  startGame() {
    const levelSetting = this.gameSetting.level[this.state.level];
    this.setState({
      showHowtoplay: false,
      showLevel: false,
      currentDigit: 0,
      action: "cooldown",
      question: randomDigit(levelSetting.digit),
    });
    this.lastUpdate = null;
    this.animationID = requestAnimationFrame((now) => this.gameLoop(now));
  }

  showHowtoPlay() {
    this.setState({
      showIntro: false,
      showHowtoplay: true,
    });
  }

  handleDigitClick = (digit) => {
    const { values } = this.state;
    const emptyIndex = values.findIndex((value) => value === "");
    if (emptyIndex !== -1) {
      const updatedValues = [...values];
      updatedValues[emptyIndex] = digit.toString();
      this.setState({ values: updatedValues });
      setTimeout(() => {
        if (this.state.values.every((item) => item !== "")) {
          this.clickAnswer();
        }
      }, 1);

      if (this.inputRefs[emptyIndex + 1]) {
        this.inputRefs[emptyIndex + 1].focus();
      }
    }
  };

  handleReset = () => {
    this.setState({
      values: new Array(this.gameSetting.level[this.state.level].digit).fill(
        ""
      ),
    });
    this.inputRefs.forEach((text) => {
      text.value = "";
    });
  };

  handleDelete = () => {
    const { values } = this.state;

    const lastFilledIndex = values
      .slice()
      .reverse()
      .findIndex((value) => value !== "");

    if (lastFilledIndex !== -1) {
      const correctedIndex = values.length - 1 - lastFilledIndex;

      const updatedValues = [...values];
      updatedValues[correctedIndex] = "";

      this.setState({ values: updatedValues });

      if (this.inputRefs[correctedIndex]) {
        this.inputRefs[correctedIndex].focus();
      }
    }
  };
  onInput(e, i) {
    const { values } = this.state;
    const updatedValues = [...values];
    updatedValues[i] = e.target.value;
    this.setState({ values: updatedValues });

    if (e.target.value.length > 0) {
      if (i === this.state.question.length - 1) {
        setTimeout(() => {
          this.clickAnswer();
        }, 100);
      } else {
        this.inputRefs[i + 1].focus();
      }
    }
  }
  gameLoop(now) {
    if (!this.lastUpdate) {
      this.lastUpdate = now;
    }

    const delta = now - this.lastUpdate;
    const levelSetting = this.gameSetting.level[this.state.level];

    switch (this.state.action) {
      case "cooldown":
        if (delta > levelSetting.cooldownTime) {
          if (this.state.currentDigit === levelSetting.digit) {
            this.setState({ action: "answer" });
          } else {
            this.setState((state) => ({
              action: "display",
              currentDigit: state.currentDigit + 1,
            }));
          }
          this.lastUpdate = now;
        }
        break;

      case "display":
        if (delta > levelSetting.displayTime) {
          this.setState({ action: "cooldown" });
          this.lastUpdate = now;
        }
        break;
      case "answer":
        if (delta > levelSetting.answerTime) {
          this.nextLevel("timeout");
          this.lastUpdate = now;
        }
        break;

      default:
    }

    if (this.animationID) {
      this.animationID = requestAnimationFrame((now) => this.gameLoop(now));
    }
  }

  nextLevel(levelResult, responseTime = 0) {
    cancelAnimationFrame(this.animationID);
    this.animationID = null;
    this.lastUpdate = null;

    const nextLevel = this.state.level + 1;
    const nextLevelDigit =
      this.gameSetting.level[nextLevel] !== undefined
        ? this.gameSetting.level[nextLevel].digit
        : this.gameSetting.level[this.state.level].digit;

    this.setState((state) => ({
      level: state.level + 1,
      showLevel: true,
      passLevel: levelResult === "correct",
      result: Object.assign([], state.result, {
        [this.state.level]: { result: levelResult, responseTime },
      }),
      values: new Array(nextLevelDigit).fill(""),
    }));
  }

  clickAnswer() {
    const ans = [...Array(this.state.question.length).keys()]
      .map((i) => this.state.values[i])
      .join("");

    if (ans.length !== this.state.question.length) return;

    const now = new Date();

    if (this.type === "backward") {
      this.nextLevel(
        ans === this.state.question.split("").reverse().join("")
          ? "correct"
          : "wrong",
        now - this.questionShowAt
      );
    } else {
      this.nextLevel(
        ans === this.state.question.split("").reverse().join("")
          ? "correct"
          : "wrong",
        now - this.questionShowAt
      );
    }
  }
  async endGame() {
    this.props.submitResult(this.state.result);


    let count = 0;
    this.gameSetting.level.forEach((levelSetting, idx) => {
      if (!levelSetting.practice && this.state.result[idx]) {       
        count++;
      }
    });

    if (count > 0) {
      let data = {
          [this.state.id]: {1:this.state.result
            .filter((answer, index) => index !== 0 && answer !== '') 
            .map((answer,no) => ({
                no,
                result: answer.result,
                responseTime: answer.responseTime
              }))
        }};
      this.props.updateAllResult(data);
    }
    this.props.forceEndGame();
  }

  nextGame() {
    this.props.submitResult(this.state.id, this.state.result);


    let count = 0;
    this.gameSetting.level.forEach((levelSetting, idx) => {
      if (!levelSetting.practice && this.state.result[idx]) {       
        count++;
      }
    });

    if (count > 0) {
        let data = {
          [this.state.id]: {1:this.state.result
            .filter((answer, index) => index !== 0 && answer !== '') 
            .map((answer,no) => ({
                no,
                result: answer.result,
                responseTime: answer.responseTime
              }))
        }};
        this.props.updateAllResult(data);
    }

    this.props.navigateNextPage();
  }

  render() {
    const levelSetting = this.gameSetting.level[this.state.level];

    if (this.state.showIntro) {
      return (
        <IntroGame icon={GameData[2].gamePic} headname="เกมทดสอบที่ 3 :">
          <Button onClick={() => this.showHowtoPlay()}>ทำการทดสอบ</Button>
        </IntroGame>
      );
    }
    if (this.state.showHowtoplay) {
      return (
        <div>
          <Howtoplay id={"3"} />
          <Button onClick={() => this.startGame()}>ทดลองเล่น</Button>
        </div>
      );
    }
    if (this.state.showLevel) {
      const levelSetting = this.gameSetting.level[this.state.level] ?? {};
      const prevLevelSetting =
        this.gameSetting.level[this.state.level - 1] ?? {};
      const levelScore =
        this.state.result[this.state.level - 1].result === "correct" ? 1 : 0;
      const totalmilliTime =
        this.state.result[this.state.level - 1].responseTime === 0
          ? 5000
          : this.state.result[this.state.level - 1].responseTime;
      const totalTime = (totalmilliTime / 1000).toFixed(2);

      return (
        <div className={styles.passpracetice}>
          {this.state.isModalEndGame && (
            <ModalEndGame
              onClose={() => this.endGame()}
              onCancel={() => this.setState({ isModalEndGame: false })}
            />
          )}
          {!prevLevelSetting ||
          (prevLevelSetting.practice && !levelSetting.practice) ? (
            <>
              {this.state.passLevel ? (
                <Passpracetice pass={true}>
                  คุณผ่านการทดลองเล่นแล้ว ต่อไปคือการทดสอบจริง
                </Passpracetice>
              ) : (
                <>
                  <Passpracetice pass={false}>
                    คุณยังไม่ผ่านการทดลองเล่น ต้องการทดลองเล่นเกมนี้อีกครั้งไหม
                  </Passpracetice>
                  <Button onClick={() => this.restartGame()}>
                    ทดลองเล่นอีกครั้ง
                  </Button>
                </>
              )}
            </>
          ) : (
            <>
              {this.state.passLevel ? (
                <>
                  <StatusGame status={"Pass"}>
                    ยินดีด้วย คุณผ่านการทดสอบ <br />
                    {prevLevelSetting.name} แล้ว
                    <br />
                    มาทดสอบระดับต่อไปกัน
                  </StatusGame>
                  <LevelResult
                    name={"Game DigitalSpan"}
                    score={levelScore}
                    fullscore={1}
                    time={totalTime}
                  />
                </>
              ) : (
                <>
                  <StatusGame status={"Fail"}>
                    คุณไม่ผ่านการทดสอบ 
                    <br/>ไม่ต้องเสียใจนะ<br></br>
                    ยังมีเกมที่ 4 รอคุณอยู่
                  </StatusGame>
                  <LevelResult
                    name={"Game DigitalSpan"}
                    score={levelScore}
                    fullscore={1}
                    time={totalTime}
                  />
                </>
              )}
            </>
          )}
          {(this.state.passLevel &&
            this.state.level < this.gameSetting.level.length) ||
          (prevLevelSetting && prevLevelSetting.practice) ? (
            <ButtonNextLevel
              onClick={() => this.startGame()}
              Nextlevel={levelSetting.level}
            >
              {prevLevelSetting.practice
                ? levelSetting.practice
                  ? "ทดลองเล่นระดับต่อไป"
                  : this.state.passLevel
                  ? "เริ่มการทดสอบ"
                  : "ไม่ ฉันต้องการไปเริ่มทำการทดสอบ"
                : "ทดสอบระดับต่อไป"}
            </ButtonNextLevel>
          ) : (
            <div className={styles.sectionEndgame}>
              <ButtonNextGame onClick={() => this.nextGame()}>
                ทดสอบเกมต่อไป
              </ButtonNextGame>
              <ButtonEndGame
                onClick={() => this.setState({ isModalEndGame: true })}
              >
                จบการทำแบบทดสอบ
              </ButtonEndGame>
            </div>
          )}
        </div>
      );
    }

    return (
      <>
        {this.state.action === "display" ? (
          <div className={styles.body}>
            <Game
              name={levelSetting.name}
              round={this.state.round}
              levelRound={levelSetting.round}
              id={"3"}
            >
              <div className={styles.bodyquestion}>
                {this.state.action === "display" && (
                  <div className={styles.display}>
                    {this.state.question.split("")[this.state.currentDigit - 1]}
                  </div>
                )}
              </div>
            </Game>
          </div>
        ) : null}
        {this.state.action === "answer" ? (
          <div className={styles.body}>
            <div style={{ marginBottom: "20px" }}>
              <div className={styles.timer}>
                <CountdownTimer initialTime={levelSetting.answerTime} />
              </div>
              <Game
                name={levelSetting.name}
                round={this.state.round}
                levelRound={levelSetting.round}
                id={"3"}
              >
                <div className={styles.bodyquestion}>
                  {this.state.action === "display" && (
                    <div className={styles.display}>
                      {
                        this.state.question.split("")[
                          this.state.currentDigit - 1
                        ]
                      }
                    </div>
                  )}
                </div>
                <div className={styles.answer}>
                  {this.state.values.map((value, i) => (
                    <NumberInput
                      key={i}
                      ref={(el) => (this.inputRefs[i] = el)} // Store the ref for each input
                      value={value}
                      onChange={(e) => this.onInput(e, i)}
                      autoFocus={i === 0}
                      phone={this.state.thisMobile}
                    />
                  ))}
                </div>
                <Numpad
                  onDigitClick={this.handleDigitClick}
                  onResetClick={this.handleReset}
                  onDeleteClick={this.handleDelete}
                />
              </Game>
            </div>
          </div>
        ) : this.state.action === "display" ? null : (
          <Waiting />
        )}
      </>
    );
  }
}

const WrapperGameChoiceReaction = (props) => {
  const { id ,updateAllResult} = useData();

  return <GameDigitalSpanBackward guid={id} updateAllResult={updateAllResult} {...props} />;
};
export class GameDigitalSpanBackward extends GameDigitalSpan {
  constructor() {
    super("backward");
  }
}

export default WrapperGameChoiceReaction;
